import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.openWaze}},[_c('span',[_vm._v(_vm._s(_vm.address))]),(_vm.address)?_c(VIcon,[_vm._v("mdi-waze")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }